'use strict';

var React = require('react');
var index = require('./index-fccd5f88.js');
var Icons = require('./Icons-46f5553f.js');
var Typography = require('./Typography-8468e4cf.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = "/*Hearted Animation*/\n@keyframes Link_module_grow__bff07102 {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(1.2);\n  }\n}\n@keyframes Link_module_shrink__bff07102 {\n  0% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.Link_module_visuallyHidden__bff07102 {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.Link_module_youtubeVideo__bff07102 {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.Link_module_Link__bff07102 {\n  text-decoration: underline;\n  cursor: pointer;\n  text-decoration: none;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n  height: auto;\n  transition: all 0.2s ease-in-out;\n  display: inline-flex;\n  gap: 8px;\n}\n.Link_module_Link__bff07102:hover {\n  text-decoration: underline;\n}\n.Link_module_Link__bff07102:focus {\n  outline: none;\n}\n.Link_module_Link__bff07102:focus-visible {\n  outline: none;\n  border-radius: 4px;\n  color: #444F6B !important;\n  box-shadow: 0px 0px 0px 4px #ffffff, 0px 0px 0px 7px #7f5f9c, 1px 8px 16px rgba(25, 25, 25, 0.2);\n  background-color: #ffffff;\n}\n.Link_module_Link__bff07102:focus-visible span {\n  color: #444F6B !important;\n}\n.Link_module_Link__bff07102 svg {\n  flex-shrink: 0;\n}\n\n.Link_module_Label__bff07102 {\n  width: 100%;\n}\n\n.Link_module_LeftIcon__bff07102 svg {\n  order: 0;\n  flex-shrink: 0;\n}\n\n.Link_module_RightIcon__bff07102 svg {\n  order: 2;\n  flex-shrink: 0;\n}\n\n.Link_module_Icon__bff07102:hover {\n  transform: scale(1.2);\n}\n.Link_module_Icon__bff07102 span {\n  display: block;\n  clip: rect(0 0 0 0);\n  clip-path: inset(100%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.Link_module_Underline__bff07102 {\n  text-decoration: underline;\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Atoms/Links/Link.module.scss");
var modules_e20967e9 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"Link_module_visuallyHidden__bff07102","youtubeVideo":"Link_module_youtubeVideo__bff07102","Link":"Link_module_Link__bff07102","Label":"Link_module_Label__bff07102","LeftIcon":"Link_module_LeftIcon__bff07102","RightIcon":"Link_module_RightIcon__bff07102","Icon":"Link_module_Icon__bff07102","Underline":"Link_module_Underline__bff07102","grow":"Link_module_grow__bff07102","shrink":"Link_module_shrink__bff07102"};

function Link(_ref) {
  var action = _ref.action,
    ariaCurrent = _ref.ariaCurrent,
    ariaExpanded = _ref.ariaExpanded,
    bold = _ref.bold,
    color = _ref.color,
    ellipsis = _ref.ellipsis,
    extraBold = _ref.extraBold,
    extraClass = _ref.extraClass,
    fontSize = _ref.fontSize,
    href = _ref.href,
    icon = _ref.icon,
    iconColor = _ref.iconColor,
    iconHSize = _ref.iconHSize,
    iconName = _ref.iconName,
    iconWSize = _ref.iconWSize,
    id = _ref.id,
    label = _ref.label,
    maxWidth = _ref.maxWidth,
    rightIcon = _ref.rightIcon,
    serif = _ref.serif,
    target = _ref.target,
    textDecorationLine = _ref.textDecorationLine,
    textUnderlineOffset = _ref.textUnderlineOffset,
    textDecorationThickness = _ref.textDecorationThickness,
    title = _ref.title,
    underline = _ref.underline,
    uppercase = _ref.uppercase;
  return /*#__PURE__*/React__default["default"].createElement("a", {
    id: id,
    "aria-expanded": ariaExpanded,
    "aria-current": ariaCurrent,
    className: [modules_e20967e9.Link, extraClass || "", rightIcon ? modules_e20967e9.RightIcon : modules_e20967e9.LeftIcon, underline ? modules_e20967e9.Underline : "", icon ? modules_e20967e9.Icon : ""].join(" "),
    href: href,
    onClick: action,
    target: target,
    style: {
      color: color ? color : "#444f6b",
      textDecorationLine: textDecorationLine,
      textDecorationThickness: textDecorationThickness,
      textUnderlineOffset: textUnderlineOffset
    }
  }, iconName ? /*#__PURE__*/React__default["default"].createElement(Icons.Icon, {
    extraClass: modules_e20967e9.Icon,
    iconColor: iconColor,
    iconHSize: iconHSize || 24,
    iconName: iconName,
    iconWSize: iconWSize || 24
  }) : "", /*#__PURE__*/React__default["default"].createElement(Typography.Span, {
    extraClass: modules_e20967e9.Label,
    title: title,
    extraBold: extraBold,
    maxWidth: maxWidth,
    ellipsis: ellipsis,
    bold: bold == false ? bold : true,
    fontSize: fontSize,
    serif: serif,
    color: color,
    uppercase: uppercase
  }, label));
}
Link.propTypes = {
  action: index.propTypes.exports.func,
  ariaCurrent: index.propTypes.exports.oneOfType([index.propTypes.exports.string, index.propTypes.exports.bool]),
  ariaExpanded: index.propTypes.exports.oneOfType([index.propTypes.exports.string, index.propTypes.exports.bool]),
  bold: index.propTypes.exports.bool,
  color: index.propTypes.exports.string,
  ellipsis: index.propTypes.exports.bool,
  extraBold: index.propTypes.exports.bool,
  extraClass: index.propTypes.exports.string,
  fontSize: index.propTypes.exports.oneOf(["XXL", "XL", "L", "M", "BASE", "S", "XS", "XXS"]),
  href: index.propTypes.exports.string,
  icon: index.propTypes.exports.bool,
  iconColor: index.propTypes.exports.string,
  iconHSize: index.propTypes.exports.oneOfType([index.propTypes.exports.string, index.propTypes.exports.number]),
  iconName: index.propTypes.exports.string,
  iconWSize: index.propTypes.exports.oneOfType([index.propTypes.exports.string, index.propTypes.exports.number]),
  id: index.propTypes.exports.oneOfType([index.propTypes.exports.string, index.propTypes.exports.number]),
  label: index.propTypes.exports.node,
  maxWidth: index.propTypes.exports.oneOfType([index.propTypes.exports.string, index.propTypes.exports.number]),
  rightIcon: index.propTypes.exports.bool,
  serif: index.propTypes.exports.bool,
  target: index.propTypes.exports.string,
  textDecorationLine: index.propTypes.exports.string,
  textUnderlineOffset: index.propTypes.exports.string,
  textDecorationThickness: index.propTypes.exports.string,
  title: index.propTypes.exports.string,
  underline: index.propTypes.exports.bool,
  uppercase: index.propTypes.exports.bool
};

exports.Link = Link;
